import { Col, Row } from 'antd'
import React from 'react'
import { Alert } from './styles'
import { FormItem, Input } from '../styles'
import BankSelect from '../BankSelect'
import CompensationRequestByBankInputGroupHook from './CompensationRequestByBankInputGroup.hook'

function CompensationRequestByBankInputGroup() {
  const { isCreateOrEditMode, content, isRequired } = CompensationRequestByBankInputGroupHook()

  return (
    <>
      <Row gutter={16}>
        <Alert type="warning" showIcon message={content} />
      </Row>
      <Row gutter={16}>
        <Col className="gutter-row" span={6}>
          <FormItem name="bankProvider" label="ชื่อธนาคาร *" rules={[isRequired]}>
            <BankSelect />
          </FormItem>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col className="gutter-row" span={6}>
          <FormItem name="bankBranchName" label="ชื่อสาขา *" rules={[isRequired]}>
            <Input placeholder="ระบุ" disabled={!isCreateOrEditMode} />
          </FormItem>
        </Col>
        <Col className="gutter-row" span={6}>
          <FormItem name="bankAccountNumber" label="เลขที่บัญชี *" rules={[isRequired]}>
            <Input placeholder="ระบุ" disabled={!isCreateOrEditMode} />
          </FormItem>
        </Col>
        <Col className="gutter-row" span={6}>
          <FormItem name="bankAccountName" label="ชื่อบัญชี *" rules={[isRequired]}>
            <Input placeholder="ระบุ" disabled={!isCreateOrEditMode} />
          </FormItem>
        </Col>
      </Row>
    </>
  )
}

export default CompensationRequestByBankInputGroup
